/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ImageUpload = {
    imageBase64: string;
    fileType: string;
};
export type mutationsUpdateUserMutationVariables = {
    userID: string;
    firstname?: string | null;
    lastname?: string | null;
    password?: string | null;
    profileImage?: ImageUpload | null;
};
export type mutationsUpdateUserMutationResponse = {
    readonly updateUser: {
        readonly id: string;
    };
};
export type mutationsUpdateUserMutation = {
    readonly response: mutationsUpdateUserMutationResponse;
    readonly variables: mutationsUpdateUserMutationVariables;
};



/*
mutation mutationsUpdateUserMutation(
  $userID: ID!
  $firstname: String
  $lastname: String
  $password: String
  $profileImage: ImageUpload
) {
  updateUser(input: {firstname: $firstname, lastname: $lastname, password: $password, userID: $userID, profileImage: $profileImage}) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "firstname"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastname"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "password"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "profileImage"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userID"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "firstname",
            "variableName": "firstname"
          },
          {
            "kind": "Variable",
            "name": "lastname",
            "variableName": "lastname"
          },
          {
            "kind": "Variable",
            "name": "password",
            "variableName": "password"
          },
          {
            "kind": "Variable",
            "name": "profileImage",
            "variableName": "profileImage"
          },
          {
            "kind": "Variable",
            "name": "userID",
            "variableName": "userID"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "updateUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsUpdateUserMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "mutationsUpdateUserMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "d489c24e926c305704e89c9fa4c55fec",
    "id": null,
    "metadata": {},
    "name": "mutationsUpdateUserMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsUpdateUserMutation(\n  $userID: ID!\n  $firstname: String\n  $lastname: String\n  $password: String\n  $profileImage: ImageUpload\n) {\n  updateUser(input: {firstname: $firstname, lastname: $lastname, password: $password, userID: $userID, profileImage: $profileImage}) {\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '59ed1fe1ae017c10ea7d09626c322fb5';
export default node;
